import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Avatar, Spin, Empty, Pagination } from 'antd';
import {  manuscriptList, getZipPath, download, getAllZipPath } from '../../../../actions/majorProjects';
import Scrollbars from 'react-custom-scrollbars';
import time from '../../images/time.png';
import task from '../../images/task.png';
import './index.scss';
import {applicationName} from "../../../../utils";

//稿件列表页面
const Manuscript = (props) => {


    const [current, setCurrent] = useState(1);
    const [manuscriptData, setManuscriptData] = useState(props.manuscriptData ? props.manuscriptData : { list: [], pageSize: 5, total: 0 });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        //调用查询列表接口
        if (props.id !== undefined) {
            search(current);

        }

    }, [current])

    const changePage = (page) => {
        setCurrent(page);
    }

    //下载稿件
    const downLoadOneFile = (id) => {
        getZipPath({ storyIds: id }, (data) => {
            download(`zipPath=${encodeURIComponent(data)}`, (url => {
                let a = document.createElement("a");
                a.href = url;
                document.body.append(a); // 修复firefox中无法触发click
                a.click();
                document.body.removeChild(a);
                window.open(url, "_self");
            }))
        })
    }

    //下载所有稿件
    const downLoadAll = () => {
        //记得先查询所有稿件
        //let ids = [];
        if (manuscriptData.list.length === 0) {
            return;
        }
        //manuscriptData.list.map((item, index) => ids.push(item.id))
        getAllZipPath({interviewEventId: props.id}, (data) => {
            console.log(encodeURIComponent(data))
            download(`zipPath=${encodeURIComponent(data)}`, (url => {
                let a = document.createElement("a");
                a.href = url;
                document.body.append(a); // 修复firefox中无法触发click
                a.click();
                document.body.removeChild(a);
                window.open(url, "_self");
            }))
        })
    }

    const search = (current) => {
        let formData = {
            start: current,
            size: 5,
            id: props.id, ///项目id
            resourceType: 1,
            url: props.listUrl

        }
        setLoading(true)
        manuscriptList(formData, function (res) {
            setLoading(false)
            if (res.code === 0) {
                if (props.url === undefined) {
                    let data = [];
                    if( res.data && res.data.length > 0){

                        res.data.map((item,index)=>{
                            if(item.story){
                                let submitStatusName = '';
                                if (item.copyStorys.length > 0) {
                                    item.copyStorys.forEach(copyStoryItem => {
                                        if (copyStoryItem.statusName === '发布') {
                                            submitStatusName = '已发布';
                                            return;
                                        }
                                    });
                                    if (submitStatusName !== '已发布') {
                                        if (item.statusName === '发布') {
                                            submitStatusName = '已发布';
                                        } else {
                                            submitStatusName =item.story? item.story.statusName:'';
                                        }
                                    }
                                }else{
                                    submitStatusName =item.story? item.story.statusName:'';
                                }

                                    item.story.statusName=submitStatusName;
                                console.log(submitStatusName)
                                data.push(item.story)
                            }else {
                                data.push(item)
                            }
                        })
                    }

                   /* res.data && res.data.length > 0 &&
                    res.data.map((item => item.story ? data.push(item.story) : data.push(item)))*/


                    setManuscriptData({ list: data, pageSize: 5, total: res.count });
                } else {
                    setManuscriptData({ list: res.data, pageSize: 5, total: res.count });

                }

            }
        })
    }

    //导出列表
    const exportList = () => {

        const headers = {
            "Pragma": 'no-cache',
            'Cache-Control': 'no-cache',
            'Content-Type': ' application/x-www-form-urlencoded; charset=UTF-8',
          };
          if (manuscriptData.list && manuscriptData.list.length > 0) {
            fetch("/cm-sites-" + applicationName() + `/excelExport/exportInterviewEventAllStory?interviewEventId=${props.id}`, {
              method: 'GET',
              cache: 'no-cache',
              headers: headers,
              credentials: 'include',
              responseType: 'blob'
            }).then(response => response.blob().then(blob => {
              var alink = document.createElement('a');
              alink.style.display = 'none'
              alink.href = window.URL.createObjectURL(blob);
              alink.download = decodeURIComponent(response.headers.get('Content-Disposition').split(';filename=')[1]);   // 设置文件名
              document.body.appendChild(alink)
              alink.click();
              URL.revokeObjectURL(alink.href) // 释放URL 对象
              document.body.removeChild(alink)
            })).catch((error) => {
              alert(error)
            })
          }
    }

    console.log(manuscriptData)

    return (
        <div className="manuscript">
            {
                loading ? <Spin className="loading"/> :  
                manuscriptData.list && manuscriptData.list.length === 0 ? <Empty className="noData" /> :
                <>
                <div className="list">

                <Scrollbars style={{ height: 520 }}>
                    {
                        <Spin className="loading" spinning={loading}>
                            {
                                manuscriptData.list.length === 0 ? <Empty className="noData" /> :
                                    manuscriptData.list.map((item, index) => {
                                        let account='';
                                        if(item.user&&item.user.name){
                                            account=item.user.name;
                                        }else if(item.account){
                                            account=item.account
                                        }
                                        return(
                                            <div className="item" key={item.id}>
                                                <div className="line_1">
                                                    <div className="left">
                                                        {/* 对应字段 */}
                                                        {(() => {
                                                            let photo = "images/header_boys.png";
                                                            if (item.user) {
                                                                let sex = item.user.sex;
                                                                if (item.user.photoUrl) {
                                                                    photo = item.user.photoUrl;
                                                                } else {
                                                                    if (sex === 2) {
                                                                        photo = "/images/header_girls.png";
                                                                    }
                                                                }
                                                            } else { //
                                                                photo = item.submitterAvatar
                                                            }
                                                            return <Avatar src={photo} />
                                                        })()}
                                                        {account?<span>{account}</span>:null}
                                                        <span>{item.statusName}</span>
                                                        <img src={time} alt="" style={{ marginLeft: 10 }} />
                                                        <span>{item.changeDate?window.formatDate(item.changeDate):''}</span>
                                                        {item.projectName && <img src={task} alt="" style={{ marginLeft: 10 }} />}
                                                        {/* //属于哪个项目 */}
                                                      {item.projectName && <span>{item.projectName}</span>}
                                                    </div>
                                                    <div className="right">
                                                        <span onClick={() => downLoadOneFile(item.id)}>下载稿件</span>
                                                    </div>
                                                </div>
                                                <div className="line_2 text-pointer" style={{ cursor:"pointer"}} title={item.title} onClick={ props.listUrl ? () => {
                                                    let url = `/cm-sites/pms/addContribute/addContributeNews.html?eiditStoryId=${item.id}&attribute=original&actButtonId=30&isShowMainColumnSetBtn=false&passMediaCodes=`;
                                                    window.openFull(url, "稿件编辑", function () {
                                                    }, {
                                                        shade: 0.5,
                                                        area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
                                                    }, function () {
                                                        search(current);
                                                    })
                                                } : () => { window.open('/cm-sites/pms/framereact/index.html?#/preview/page/'+item.id+'/1','_blank');}}>
                                                    {item.title}
                                                    {/* //对应字段 */}
                                                    {/*抗议前线受考验 一线入党照初心————北京市清华长庚医院召开防疫一线党员发展大会*/}
                                                </div>
                                                <div className="line_3">
                                                    {/* //对应字段 */}
                                                    {item.summary}
                                                    {/*清华新闻网9月2日电(通讯员 郭凯华 周英哲)  “我志愿加入中国共产党，拥护党的纲领，遵守党的章程，履行党员义务...” 8月28日下午，北京清华长庚医院内科第二党支部召开了一场特殊的党员发展会，经内科第二党支部召开支部大讨论、表决，同意接收两次战斗在武汉、北京抗击疫情第一线的姚洁琳同志为中共预备党员。*/}
                                                </div>
                                            </div>
                                    )}
                                    )
                            }

                        </Spin>
                    }
                </Scrollbars>
                <Pagination
                    style={{ display: 'flex', justifyContent: 'flex-end', padding: '20px' }}
                    current={current}
                    pageSize={manuscriptData.pageSize}
                    total={manuscriptData.total}
                    onChange={changePage}
                />
            </div>
            {
                props.listUrl ? '' : 
                <div className="footer">
                <span onClick={downLoadAll}>下载全部稿件</span>
                <span onClick={exportList}>导出列表</span>
            </div>
                
            }
              
           </>
            }
         
        </div>
    )
}

Manuscript.propTypes = {
    id: PropTypes.number,
}



export default Manuscript




